<div class="body">
    <mat-toolbar class="ams-toolbar">
        <button mat-icon-button>
            <mat-icon>notifications_none</mat-icon>
        </button>
        <span>Benachrichtigungen</span>
        <span class="spacer"></span>
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-toolbar>
    <div class="content widget-list-content" style="overflow-y: auto;">

        <ng-container *ngIf="unseenNotifications.length > 0; else noUnseenMessages">

            <div class="headline">
                Ungelesene Nachrichten
            </div>

            <ng-container *ngFor="let notification of unseenNotifications">

                <app-notification-preview class="entry" [class.highlighted]="!notification.notificationseen" [notification]="notification" (click)="notificationSelected(notification)"></app-notification-preview>
    
            </ng-container>

        </ng-container>
        
        <ng-template #noUnseenMessages>

            <div class="no-entries-hint" style="flex: 1;">
                <div class="spacer"></div>
                <mat-icon class="icon success">done</mat-icon>
                <div class="text">keine unbearbeiteten ungelesenen Nachrichten</div>
                <div class="spacer double"></div>
            </div>

        </ng-template>
        
        <ng-container *ngIf="seenNotifications.length > 0">

            <div class="headline" style="margin-top: 20px;">
                Gelesene Nachrichten
            </div>

            <ng-container *ngFor="let notification of seenNotifications">

                <app-notification-preview class="entry" [notification]="notification" (click)="notificationSelected(notification)"></app-notification-preview>
    
            </ng-container>

        </ng-container>

        <ng-container *ngIf="errors.length > 0">

            <div class="headline" style="margin-top: 20px;">
                Fehler in aktueller Sitzung
            </div>

            <ng-container *ngFor="let notification of errors">

                <app-notification-preview class="entry error-notification" [notification]="notification" (click)="notificationSelected(notification)"></app-notification-preview>
    
            </ng-container>

        </ng-container>
        
        <div class="footer-wrapper">
            <button mat-raised-button color="primary" (click)="loadMoreEntries()">Ältere laden</button>
        </div>

    </div>

</div>